import script from "./OptionsBody.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptionsBody.vue?vue&type=script&setup=true&lang=ts"

import "./OptionsBody.vue?vue&type=style&index=0&id=79d3c2ca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d3c2ca"]])

export default __exports__